// Utility functions for preloading components
// This can be used to preload components when user interaction suggests they might be needed

export const preloadDataEntryModal = () => {
  return import('../components/DataEntryModal');
};

export const preloadWelcomePage = () => {
  return import('../pages/WelcomePage');
};

export const preloadProfilePage = () => {
  return import('../pages/ProfilePage');
};

export const preloadLoginPage = () => {
  return import('../pages/LoginPage');
};

export const preloadWorkReviewSection = () => {
  return import('../components/DataEntryTypes/WorkReviewSection');
};

export const preloadCreateInvoiceSection = () => {
  return import('../components/DataEntryTypes/CreateInvoiceSection');
};

// Preload all critical components for better UX
export const preloadCriticalComponents = () => {
  // Preload pages that users are likely to visit
  preloadWelcomePage();
  preloadProfilePage();
  
  // Preload modal only if user shows engagement with the app
  setTimeout(() => {
    preloadDataEntryModal();
  }, 2000);
};
